module.exports = __webpack_public_path__ + "static/hero2-946241c4ffd272e194bb44266400b7a0.jpg";